import { createAction, props } from '@ngrx/store';
import { Video } from '../model/video';

// Load Videos
export const loadVideos = createAction('[Video] Load Videos');
export const loadVideosSuccess = createAction('[Video] Load Videos Success', props<{ video: Video[] }>());
export const loadVideosFailure = createAction('[Video] Load Videos Failure', props<{ error: string }>());

// Add Video
export const addVideo = createAction('[Video] Add Video', props<{ video: Video }>());
export const addVideoSuccess = createAction('[Video] Add Video Success', props<{ video: Video }>());

// Update Video
export const deleteVideo = createAction('[Video] Delete Video', props<{ id: string }>());
export const deleteVideoSuccess = createAction('[Video] Delete Video Success', props<{ id: string }>());

// Select Video for Editing/View
export const selectVideo = createAction('[Video] Select Video', props<{ videoId: string }>());
